export const engagementAppGroupIdWhatsAppMessageTemplatesExternalAccountId =
  "/engagement/:app_group_id/whats_app/message_templates/:external_account_id";
